import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('bi_preset_question', {
  text: '',
  position: '',
})
